import styled from 'styled-components'

export const StyledTextImageAdmin = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
`
export const StyledButton = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
`
export const StyledInputs = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
`
export const StyledText = styled.div`
  width: 50%;
`
export const StyledImage = styled.div`
  width: 50%;
`
